module.exports = __webpack_public_path__ + "static/media/pf17.055e13c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/pf17.png
// module id = 2658
// module chunks = 0